module.exports = __webpack_public_path__ + "img/4.1ebca86e.png";